/* import GruntPager from '../custom/GruntPager';
import { TableContainer, Table,Thead,Tr,Th,Td,Tbody,Text,Box, Tooltip, IconButton,Input, InputLeftElement, InputGroup, Spacer } from '@chakra-ui/react';
import {SmallCloseIcon,SearchIcon} from '@chakra-ui/icons';
import { useState } from 'react';

export default function GovedaSelected({data=[],size='xs',naslov="Odabrana goveda",naslovisvisible=true,readonly=true,onDelete,columns=[true,true,true,true,true,true]}) {
    const [prikaz, setPrikaz] = useState({rowsperpage:100,currpage:1})
    const [filter,setFilter]=useState("")
    const showBrOdabranih=()=>{
        return (
          <Text fontSize={'xs'}>Odabrano goveda: {data.length}</Text>
        )
      }
      const deleteGovedoFromSelection=(govid)=>{
        if (onDelete!==undefined) {
            onDelete(govid);    
        }
        
        
    }
    const govSort=(a,b)=>{
        if (a.zivbr>b.zivbr) {
            return 1
        } else {
            return -1;
        }
    }
    const handleFilter=(e)=>{
        //const _val=e.target.value;
        //let _ar=state.goveda;
       
        const _val0=e.target.value.toUpperCase();
        const _val=_val0.replaceAll("_",".").replaceAll("*",".*");

        const _rgxstr="^.*" + _val+"$"; 
        const _r=new RegExp(_rgxstr);
        let _test=false;
        let _i=0;
        data.forEach((gov)=>{
          _test=_r.test(gov.zivbr) || _val0==="";
          gov.filtered=_test;
          if (_test) {
            _i++;
          }

        })
        
        setPrikaz({...prikaz,currpage:1});
        setFilter(_val0);
        //setState({...state,goveda:_ar,filter:_val0});
        //setPrikaz({...prikaz,numOfRowsToShow:_i,currpage:1});
        
    }
    const getFilteredData=()=>{
        return data.sort(govSort).filter((item)=>item.filtered==true || item.filtered===undefined);
    }
    const showData=()=>{
       if (data.length>0) {
        
       
            return (
                <Box display={'flex'} flexDir={'column'} flex={1}>
                    {naslovisvisible?
                    <Box bg={'grunt2.700'} color={'white'} rounded={'sm'}>
                        <Text fontSize={'sm'} ml={'0.5rem'} fontWeight={'semibold'}>{naslov}</Text>
                    </Box>:null}
                    <InputGroup size={size} m={'0.5rem'} w={'20rem'} alignContent={'center'}>
                        <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                        <Input focusBorderColor='grunt2.400' value={filter} variant={'outline'} placeholder={'* (više znakova), _ (jedan znak)'} w={'20rem'} onChange={handleFilter}></Input>
                    </InputGroup>
                    <TableContainer>
                        <Table size='xs'>
                            <Thead _hover={{cursor:'pointer'}}>
                                <Tr>
                                    {columns[0]?<Th visibility={false} fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}></Th>:null}
                                    {columns[1]?<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni broj</Th>:null}
                                    {columns[2]?<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>:null}
                                    {columns[3]?<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>:null}
                                    {columns[4]?<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum dolaska</Th>:null}
                                    {columns[5]?<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Boks</Th>:null}
                                    {columns[6]?<Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopRightRadius={'sm'}>Oznaka</Th>:null}
                                    </Tr>
                            </Thead>
                            <Tbody>
                            {getFilteredData().slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,index)=>{
                            return (
                                <Tr  key={item.govedo_id}  bg={'white'} fontWeight={'normal'} color={'black'}
                                    _hover={{bg:'gray.100',cursor:'pointer'}} h={'2rem'}>
                                    
                                    {columns[0]?<Td fontSize={size} textAlign={'center'}>
                                        <IconButton size={'xs'} variant={'outline'}
                                            colorScheme='grunt2'
                                            aria-label='Ukloni'
                                            icon={<SmallCloseIcon color={'red'}/>}
                                            onClick={()=>onDelete(item.govedo_id)}
                                            />
                                        </Td>:null}
                                        {columns[1]?<Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>:null}
                                        {columns[2]?<Td fontSize={size} textAlign={'center'}>{item.spol}</Td>:null}
                                        {columns[3]?<Td fontSize={size} textAlign={'center'}>{item.pasmina_naziv}</Td>:null}
                                        {columns[4]?<Td fontSize={size} textAlign={'center'}>{new Date(item.datum_dolazak).toLocaleDateString('hr-HR')}</Td>:null}
                                        {columns[5]?<Td fontSize={size} textAlign={'center'}>
                                            <Tooltip label={item.boks_naziv} placement='left-start'>
                                            {item.boks}
                                            </Tooltip>
                                        </Td>:null}
                                        {columns[6]?<Td fontSize={size} textAlign={'center'}>{item.putnica_oznaka}</Td>:null}
                                    </Tr>
                            )    
            
            
        })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    {showBrOdabranih()}
                    <GruntPager currpage={prikaz.currpage} rowcount={getFilteredData().length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
        </Box>
            )
        }
    }
  return (
        <Box flexDirection={'column'} display={'flex'} flex={1} fontSize={'sm'} overflow={'auto'} h={'100%'}>
            {showData()}
        </Box>
  )
}
 */

import GruntPager from '../custom/GruntPager';
import { TableContainer, Table,Thead,Tr,Th,Td,Tbody,Text,Box, Tooltip, IconButton,Input, InputLeftElement, InputGroup, Spacer } from '@chakra-ui/react';
import {SmallCloseIcon,SearchIcon} from '@chakra-ui/icons';
import { useState } from 'react';

export default function GovedaSelected({data=[],size='xs',naslov="Odabrana goveda",naslovisvisible=true,readonly=true,onDelete,columns=[true,true,true,true,true,true]}) {
    const [prikaz, setPrikaz] = useState({rowsperpage:100,currpage:1})
    const [filter,setFilter]=useState("")
    const showBrOdabranih=()=>{
        return (
          <Text fontSize={'xs'}>Odabrano goveda: {data.length}</Text>
        )
      }
      /*const deleteGovedoFromSelection=(govid)=>{
        if (onDelete!==undefined) {
            onDelete(govid);    
        }
        
        
    }*/
    const govSort=(a,b)=>{
        if (a.zivbr>b.zivbr) {
            return 1
        } else {
            return -1;
        }
    }
    const handleFilter=(e)=>{
        //const _val=e.target.value;
        //let _ar=state.goveda;
       
        const _val0=e.target.value.toUpperCase();
        const _val=_val0.replaceAll("_",".").replaceAll("*",".*");

        const _rgxstr="^.*" + _val+"$"; 
        const _r=new RegExp(_rgxstr);
        let _test=false;
        let _i=0;
        data.forEach((gov)=>{
          _test=_r.test(gov.zivbr) || _val0==="";
          gov.filtered=_test;
          if (_test) {
            _i++;
          }

        })
        
        setPrikaz({...prikaz,currpage:1});
        setFilter(_val0);
        //setState({...state,goveda:_ar,filter:_val0});
        //setPrikaz({...prikaz,numOfRowsToShow:_i,currpage:1});
        
    }
    const getFilteredData=()=>{
        return data.sort(govSort).filter((item)=>item.filtered==true || item.filtered===undefined);
    }
    const showData=()=>{
       //if (data.length>0) {
        
       
            return (
                <Box display={'flex'} flexDir={'column'} flex={1} minH={0} overflow={'hidden'}>
                    {naslovisvisible?
                    <Box bg={'grunt2.700'} color={'white'} rounded={'sm'}>
                        <Text fontSize={'sm'} ml={'0.5rem'} fontWeight={'semibold'}>{naslov}</Text>
                    </Box>:null}
                    <InputGroup size={size} m={'0.5rem'} w={'20rem'} alignContent={'center'} flexShrink={0}>
                        <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                        <Input focusBorderColor='grunt2.400' value={filter} variant={'outline'} placeholder={'* (više znakova), _ (jedan znak)'} w={'20rem'} onChange={handleFilter}></Input>
                    </InputGroup>
                    <TableContainer flex={1} minH={0} overflowY={'auto'}>
                        <Table size='xs'>
                            <Thead sx={{ position:'sticky', top:0, zIndex:10 }}>
                                <Tr>
                                    {columns[0]?<Th visibility={false} fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopLeftRadius={'sm'}></Th>:null}
                                    {columns[1]?<Th fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni broj</Th>:null}
                                    {columns[2]?<Th fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>:null}
                                    {columns[3]?<Th fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>:null}
                                    {columns[4]?<Th fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum dolaska</Th>:null}
                                    {columns[5]?<Th fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Boks</Th>:null}
                                    {columns[6]?<Th fontSize={size} textAlign={'center'} zIndex='5' bg={'white'} color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} borderTopRightRadius={'sm'}>Oznaka</Th>:null}
                                    </Tr>
                            </Thead>
                            <Tbody>
                            {getFilteredData().slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,index)=>{
                            return (
                                <Tr  key={item.govedo_id}  bg={'white'} fontWeight={'normal'} color={'black'}
                                    _hover={{bg:'gray.100',cursor:'pointer'}} h={'2rem'}>
                                    
                                    {columns[0]?<Td fontSize={size} textAlign={'center'}>
                                        <IconButton size={'xs'} variant={'outline'}
                                            colorScheme='grunt2'
                                            aria-label='Ukloni'
                                            icon={<SmallCloseIcon color={'red'}/>}
                                            onClick={()=>onDelete(item.govedo_id)}
                                            />
                                        </Td>:null}
                                        {columns[1]?<Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>:null}
                                        {columns[2]?<Td fontSize={size} textAlign={'center'}>{item.spol}</Td>:null}
                                        {columns[3]?<Td fontSize={size} textAlign={'center'}>{item.pasmina_naziv}</Td>:null}
                                        {columns[4]?<Td fontSize={size} textAlign={'center'}>{new Date(item.datum_dolazak).toLocaleDateString('hr-HR')}</Td>:null}
                                        {columns[5]?<Td fontSize={size} textAlign={'center'}>
                                            <Tooltip label={item.boks_naziv} placement='left-start'>
                                            {item.boks}
                                            </Tooltip>
                                        </Td>:null}
                                        {columns[6]?<Td fontSize={size} textAlign={'center'}>{item.putnica_oznaka}</Td>:null}
                                    </Tr>
                            )    
            
            
        })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    {showBrOdabranih()}
                    <GruntPager currpage={prikaz.currpage} rowcount={getFilteredData().length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
        </Box>
            )
        
    }
  return (
        <Box flexDirection={'column'} display={'flex'} flex={1} fontSize={'sm'} overflow={'hidden'} h={'100%'} minH={0}>
            {showData()}
        </Box>
  )
}